import { useIntl } from '@/intl'
import { useState } from 'react'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    mixed: translate({ id: 'order.form.bulk.mixed' }),
    phone: translate({ id: 'orders.edit.field.phone' }),
    invalidPhone: translate({
      id: 'orders.edit.validation.phone.invalid',
    }),
  }))

  return api
}
